import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function KidsKarateScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-2076">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2077">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2078">
          <div data-id="element-2079">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2080">Class Times</h2>
            <ScheduleTable data-id="element-2081" />
          </div>
          <div data-id="element-2082">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2083">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-2084" />
          </div>
        </div>
      </div>
    </section>;
}